import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import AppShell from './components/AppShell';
import Panel from './components/Panel';
import axiosInstance from './utils/axiosInstance';
import { errorDialog } from './utils/dialog';
import { useNavigate, useParams } from 'react-router-dom';

const NewUserProductPage: React.FC = () => {
    const [form] = Form.useForm();

    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState<any>();
    const [products, setProducts] = useState<any[]>();
    const [productList, setProductList] = useState<{ value: string, label: string }[]>();
    const [selectedProduct, setSelectedProduct] = useState();
    const [selectedProductType, setSelectedProductType] = useState();

    const addUserProduct = async (userId: number, productId: number, amount: number, productType: string, unit: number, walletAdjustment?: number, orderConfirmTimeoutSeconds?: number) => {
        try {
            const response = await axiosInstance.post("admin/protected/addUserProduct", {
                userId,
                productId,
                amount,
                productType,
                unit,
                walletAdjustment,
                orderConfirmTimeoutSeconds
            })
            if (response?.data) {
                navigate(`/user/${userId}`);
            } else {
                errorDialog('Error');
            }

        } catch (error: any) {
            console.error('Error fetching data:', error);
            if (error?.response?.status === 401) {
                navigate('/login');  // Redirect to login if unauthorized
            }
        }
    };


    const onFinish = async (values: any) => {
        if (values?.amount && selectedProduct && id && selectedProductType && values?.unit)
            addUserProduct(Number(id), selectedProduct, values.amount, selectedProductType, values.unit, values.walletAdjustment, values.orderConfirmTimeoutSeconds);
    };

    const initLoad = async () => {
        const response = await axiosInstance.post("admin/protected/getUser", {
            userId: id,
        })
        setUser(response?.data?.data);

        const productRes = await axiosInstance.post("admin/protected/allProducts", {
        })
        setProducts(productRes?.data?.data);
        setProductList(productRes?.data?.data?.map((e: any) => {
            return {
                value: e.id,
                label: e.name
            }
        }));
    }

    useEffect(() => {
        initLoad();

        form.setFieldsValue({
            unit: 1
        });
    }, [])

    useEffect(() => {
        form.setFieldsValue({
            amount: products?.find(e => e.id == selectedProduct)?.price,
        });
    }, [selectedProduct])

    return (
        <AppShell
            title="新建"
            subtitle={user?.username ? `连单 · ${user.username}` : '连单'}
            actions={<Button icon={<ArrowLeftOutlined />} onClick={() => navigate(`/user/${id}`)}>返回</Button>}
        >
            <div className="mx-auto max-w-[460px]">
                <Panel>
                    <Form
                        form={form}
                        name="newUserProduct"
                        layout="vertical"
                        requiredMark={false}
                        onFinish={onFinish}
                    >
                        <div className="mb-5 flex items-center justify-between rounded-lg border border-line
                                        bg-canvas px-3 py-2.5">
                            <span className="text-[13px] text-muted">用户名</span>
                            <span className="text-[13px] font-semibold text-ink">{user?.username}</span>
                        </div>

                        <Form.Item label="选择商品">
                            <Select
                                showSearch
                                placeholder="选择商品"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={productList}
                                onChange={(e) => setSelectedProduct(e)}
                            />
                        </Form.Item>

                        <Form.Item
                            name="amount"
                            label="价钱"
                            rules={[{ required: true, message: '请输入价钱' }]}
                        >
                            <Input placeholder="价钱" type='number' />
                        </Form.Item>

                        <Form.Item
                            name="unit"
                            label="数量"
                            rules={[{ required: true, message: '请输入数量' }]}
                        >
                            <Input placeholder="数量" type='number' defaultValue={1} />
                        </Form.Item>

                        <Form.Item label="商品类型">
                            <Select
                                showSearch
                                placeholder="商品类型"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={[
                                    {
                                        value: "normal",
                                        label: '普通'
                                    },
                                    {
                                        value: "premium",
                                        label: '高级'
                                    }
                                ]}
                                onChange={(e) => setSelectedProductType(e)}
                            />
                        </Form.Item>

                        <Form.Item
                            name="walletAdjustment"
                            label="钱包调整"
                        >
                            <Input placeholder="钱包调整" type='number' />
                        </Form.Item>

                        <Form.Item
                            name="orderConfirmTimeoutSeconds"
                            label="订单确认倒计时（秒）"
                        >
                            <Input placeholder="订单确认倒计时（秒）" type='number' />
                        </Form.Item>

                        <Form.Item className="!mb-0 !mt-6">
                            <Button block size="large" type="primary" htmlType="submit">
                                创建
                            </Button>
                        </Form.Item>
                    </Form>
                </Panel>
            </div>
        </AppShell>
    );
}

export default NewUserProductPage;